import React from 'react';

// Components
import { Modal } from 'react-bootstrap';

// Types
import Nullable from '@/types/nullable';
import { Button } from '@capintel/component-lib/button';
import FormattedMessage from '../../../utils/i18n/FormattedMessage';
import { formatMessage } from '../../../utils/i18n/i18n';

type Props = {
  buttonAriaLabel?: string;
  buttonTextToLocalized?: string;
  className?: string;
  isInModal?: boolean;
  titleElement?: Nullable<JSX.Element>;
  onBack?: () => void;
};

const SecondaryHeader = ({ buttonAriaLabel, buttonTextToLocalized, className = '', isInModal = false, titleElement, onBack }: Props) => (
  <>
    {isInModal ? (
      <Modal.Header className={`secondary-header ${className}`}>
        {onBack && (
          <Button
            variant="secondary"
            appearance="text"
            size="small"
            onClick={onBack}
            icon="arrow-backward"
            iconPosition="left"
            aria-label={buttonAriaLabel ?? formatMessage('Common.BackToPreviousPage')}
          >
            <FormattedMessage id={buttonTextToLocalized || 'Common.Back'} />
          </Button>
        )}
        <Modal.Title className="title">{titleElement}</Modal.Title>
      </Modal.Header>
    ) : (
      <header className={`secondary-header ${className}`}>
        {onBack && (
          <Button
            variant="secondary"
            appearance="text"
            size="small"
            onClick={onBack}
            icon="arrow-backward"
            iconPosition="left"
            aria-label={buttonAriaLabel ?? formatMessage('Common.BackToPreviousPage')}
          >
            <FormattedMessage id={buttonTextToLocalized || 'Common.Back'} />
          </Button>
        )}
        <div className="title">{titleElement}</div>
      </header>
    )}
  </>
);

export default SecondaryHeader;
